(() => {
  const isUat = () => document.body.dataset.gdbUat === 'true';
  const emit = (action, extra = {}) => window.dispatchEvent(new CustomEvent('godisbit:booking', { detail: { action, uat: isUat(), ...extra } }));
  const params = new URLSearchParams(window.location.search);
  const allowedPackages = ['help', 'station', 'signature'];
  const allowedEvents = ['birthday', 'wedding', 'creator', 'brand', 'corporate', 'vendor', 'gifts', 'other'];
  const dubaiDate = () => {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Dubai', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    const part = type => parts.find(value => value.type === type).value;
    return `${part('year')}-${part('month')}-${part('day')}`;
  };
  const initialize = scope => {
    scope.querySelectorAll('[data-gdb-menu]').forEach(menu => {
      if (menu.dataset.gdbReady) return;
      menu.dataset.gdbReady = 'true';
      menu.querySelector('[data-gdb-menu-close]')?.addEventListener('click', () => {
        menu.open = false;
        menu.querySelector('summary').focus();
      });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
    });
    scope.querySelectorAll('[data-gdb-enquiry]').forEach(root => {
      if (root.dataset.gdbReady) return;
      root.dataset.gdbReady = 'true';
      const panel = root.closest('[data-gdb-enquiry-panel]');
      const packageSelect = root.querySelector('[data-gdb-package-select]');
      const eventSelect = root.querySelector('[data-gdb-event-select]');
      const date = root.querySelector('[data-gdb-date]');
      const flexible = root.querySelector('[data-gdb-flexible]');
      const dateHint = root.querySelector('[data-gdb-date-error]');
      const error = root.querySelector('[data-gdb-form-error]');
      const button = root.querySelector('[data-gdb-submit]');
      const simulation = root.dataset.gdbSimulation === 'true';
      const fields = [...root.querySelectorAll('input:not([type=hidden]), select, textarea')];
      const preselect = () => {
        if (allowedPackages.includes(params.get('package'))) packageSelect.value = params.get('package');
        if (allowedEvents.includes(params.get('event'))) eventSelect.value = params.get('event');
      };
      preselect();
      date.min = dubaiDate();
      const updateDate = () => {
        date.disabled = flexible.checked;
        date.required = !flexible.checked;
        date.setCustomValidity('');
        date.removeAttribute('aria-invalid');
        dateHint.hidden = true;
      };
      flexible.addEventListener('change', updateDate);
      const validate = () => {
        date.setCustomValidity('');
        if (!flexible.checked && date.value && date.value < dubaiDate()) date.setCustomValidity(root.dataset.dateError);
        const invalid = fields.filter(field => {
          if (field.type === 'text' || field.type === 'email') field.value = field.value.trim();
          const valid = field.disabled || field.checkValidity();
          if (!valid) field.setAttribute('aria-invalid', 'true');
          else field.removeAttribute('aria-invalid');
          return !valid;
        });
        dateHint.hidden = date.disabled || date.validity.valid;
        error.hidden = invalid.length === 0;
        if (invalid.length) {
          invalid[0].focus();
          invalid[0].reportValidity();
          return false;
        }
        return true;
      };
      fields.forEach(field => field.addEventListener('input', () => {
        if (field === date) date.setCustomValidity('');
        field.removeAttribute('aria-invalid');
      }));
      packageSelect.addEventListener('change', () => emit('package_selected', { package: packageSelect.value }));
      const source = root.querySelector('[data-gdb-source]');
      if (source && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) {
        const campaign = new URLSearchParams();
        ['utm_source', 'utm_medium', 'utm_campaign'].forEach(key => {
          if (params.has(key)) campaign.set(key, params.get(key).slice(0, 150));
        });
        source.value = campaign.toString();
      }
      if (simulation) {
        const success = panel.querySelector('[data-gdb-uat-success]');
        const summary = success.querySelector('[data-gdb-enquiry-summary]');
        const submit = () => {
          if (!validate()) return;
          summary.replaceChildren();
          fields.filter(field => !['checkbox', 'hidden'].includes(field.type) && (field.value || field === date)).forEach(field => {
            if (field === date && flexible.checked || !field.disabled) {
              const row = document.createElement('div');
              const term = document.createElement('dt');
              const value = document.createElement('dd');
              term.textContent = root.querySelector(`label[for="${CSS.escape(field.id)}"]`)?.textContent.replace(/\s*\*$/, '') || '';
              value.textContent = field === date && flexible.checked ? root.dataset.dateTbc : field.tagName === 'SELECT' ? field.selectedOptions[0].textContent : field.value;
              row.append(term, value);
              summary.append(row);
            }
          });
          root.hidden = true;
          success.hidden = false;
          success.querySelector('h2').focus();
          emit('enquiry_preview_completed', { package: packageSelect.value, event: eventSelect.value });
        };
        button.addEventListener('click', submit);
        root.addEventListener('keydown', event => {
          if (event.key === 'Enter' && event.target.tagName === 'INPUT' && event.target.type !== 'checkbox') {
            event.preventDefault();
            submit();
          }
        });
        success.querySelector('[data-gdb-enquiry-reset]').addEventListener('click', () => {
          fields.forEach(field => {
            if (field.type === 'checkbox') field.checked = false;
            else if (field.tagName === 'SELECT') field.selectedIndex = 0;
            else field.value = '';
            field.removeAttribute('aria-invalid');
          });
          updateDate();
          preselect();
          error.hidden = true;
          summary.replaceChildren();
          success.hidden = true;
          root.hidden = false;
          packageSelect.focus();
        });
      } else {
        root.closest('form').addEventListener('submit', event => {
          if (!validate()) { event.preventDefault(); return; }
          button.disabled = true;
          button.textContent = button.dataset.submitting;
          emit('enquiry_submit_attempt', { package: packageSelect.value, event: eventSelect.value });
        });
      }
    });
  };
  document.addEventListener('submit', event => {
    if (!event.target.matches('form[data-type="add-to-cart-form"]')) return;
    const quantity = event.target.elements.namedItem('quantity');
    if (quantity && !quantity.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      quantity.reportValidity();
    }
  }, true);
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-gdb-dialog-close]');
    if (close) close.closest('dialog').close();
    const packageLink = event.target.closest('[data-gdb-package]');
    if (packageLink) emit('package_selected', { package: packageLink.dataset.gdbPackage });
    const whatsapp = event.target.closest('[data-gdb-whatsapp]');
    if (!whatsapp) return;
    const root = document.querySelector('[data-gdb-enquiry]');
    const message = [document.body.dataset.gdbWhatsappIntro];
    root?.querySelectorAll('[data-gdb-package-select], [data-gdb-event-select], [data-gdb-date]').forEach(field => {
      if (!field.value || field.disabled) return;
      const label = root.querySelector(`label[for="${CSS.escape(field.id)}"]`)?.textContent.replace(/\s*\*$/, '');
      const value = field.tagName === 'SELECT' ? field.selectedOptions[0].textContent : field.value;
      message.push(`${label}: ${value}`);
    });
    const text = message.filter(Boolean).join('\n');
    if (isUat()) {
      event.preventDefault();
      const dialog = document.querySelector('[data-gdb-whatsapp-dialog]');
      dialog.querySelector('[data-gdb-whatsapp-message]').textContent = text;
      dialog.showModal();
      emit('whatsapp_preview_opened');
    } else {
      const url = new URL(whatsapp.href);
      url.searchParams.set('text', text);
      whatsapp.href = url.toString();
      emit('whatsapp_click');
    }
  });
  document.addEventListener('click', event => {
    if (!isUat()) return;
    const checkout = event.target.closest('[name=checkout], a[href^="/checkout"], a[href*="/checkouts/"]');
    if (checkout) event.preventDefault();
  }, true);
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
